import React from 'react';

function IconForType({ type }) {
  if (type === 'success') {
    return ( 
      <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden> 
        <path d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172 4.707 7.879a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" fill="currentColor" /> 
      </svg> 
    ); 
  }
  if (type === 'danger' || type === 'error') {
    return (
      <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path fillRule="evenodd" clipRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 102 0V7zm-1 8a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M10 18a8 8 0 100-16 8 8 0 000 16z" fill="currentColor" />
    </svg>
  );
}

function Toast({ messages = [], dismissToast }) {
  if (!messages || messages.length === 0) return null;

  return (
    <div className="app-toast-container" aria-live="polite" aria-atomic="true">
      {messages.map(msg => {
        const type = (msg.type || '').toLowerCase();
        const variant = type === 'success' ? 'toast-success' : (type === 'danger' || type === 'error') ? 'toast-error' : 'toast-info';
        return (
          <div key={msg.id} className={`toast ${variant}`} role={type === 'error' || type === 'danger' ? 'alert' : 'status'}>
            <div className="toast-content flex items-start">
              <div className="flex-shrink-0 mr-3"><IconForType type={type} /></div>
              <div className="flex-1">
                <span className="toast-text">{msg.text}</span>
              </div>
              <button onClick={() => dismissToast && dismissToast(msg.id)} aria-label="Close" className="ml-3 text-white opacity-90 hover:opacity-100">
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M6 6l8 8M14 6l-8 8" />
                </svg>
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Toast;
